<template>
  <div>
    <div class="block">
      <van-form class="creatruleForm" ref="ruleForm" @submit="getOnruleFormSubmit">
        <div class="grey"></div>

        <van-field
          class="cellRow"
          label="直播标题"
          v-model="ruleForm.title"
          maxlength="25"
          name="title"
          required
          placeholder="请输入直播标题"
          :rules="[{ required: true }]"
        />
        <!-- 图片上传 -->
        <div class="uploadImage">
          <van-field
            required
            v-model="ruleForm.imageUrl"
            name="imageUrl"
            label="直播封面"
            :rules="[{ required: true, message: '请上传直播封面' }]"
          >
            <template #input>
              <upload-image
                :uploadShow="uploadShow"
                :imageUrl="imageUrl"
                @success="uploadImageSuccess"
                @delete="deleteLogoImage"
              ></upload-image>
            </template>
          </van-field>
          <p class="proposalImage">建议宽x高为732x996像素同等比例尺</p>
        </div>
        <div class="grey"></div>
        <!-- select -->
        <van-field
          required
          class="cellRow iconRight"
          left-icon="info-o "
          @click-left-icon="
            portrait(
              '”普通导购直播”，可以在直播间关联商品售卖；”拍品导购直播”，可以在直播间关联拍品售卖',
            )
          "
          v-model="ruleForm.showTypePicker"
          label="直播类型"
          :disabled="isEdit"
          readonly
          name="type"
          :value="ruleForm.type"
          right-icon="arrow-down"
          @click-right-icon="onGetItem('0')"
          @focus="onGetItem('0')"
          :rules="[{ required: true, message: '请选择直播类型' }]"
        />

        <van-cell
          v-show="ruleForm.type == 3"
          center
          title="拍卖设置"
          class="title isMore"
          is-link
          @click="isMoreShow(true)"
          :arrow-direction="isMore ? 'down' : ''"
        >
        </van-cell>
        <van-field
          class="cellRow iconRight"
          v-show="isMore"
          v-model="ruleForm.marginPaymentTypeText"
          :disabled="isEdit && ruleForm.roomStatus != 0"
          label="保证金缴纳方式"
          readonly
          clickable
          required
          name="marginPaymentType"
          :value="ruleForm.liveAuctionInfo.marginPaymentType"
          right-icon="arrow-down"
          @focus="onGetItem('4')"
          @click-right-icon="onGetItem('4')"
          :rules="[{ required: isMore, message: '请选择保证金缴纳方式' }]"
        />
        <van-field
          required
          :disabled="isEdit && ruleForm.roomStatus != 0"
          class="cellRow iconRight"
          v-show="ruleForm.marginPaymentTypeText == '专场保证金' && isMore"
          v-model="ruleForm.liveAuctionInfo.marginAmount"
          label="专场保证金"
          name="marginAmount"
          :value="ruleForm.liveAuctionInfo.marginAmount"
          :rules="[
            {
              required:
                ruleForm.marginPaymentTypeText == '专场保证金' &&
                ruleForm.liveAuctionInfo.marginAmount == '' &&
                isMore,
              message: '请输入专场保证金',
            },
          ]"
        />
        <!-- <van-field
          :disabled="isEdit && ruleForm.roomStatus != 0"
          class="cellRow iconRight"
          v-show="isMore"
          v-model="ruleForm.liveAuctionInfo.artworkBidTime"
          readonly
          clickable
          required
          label="单件拍品的出价时间"
          maxlength="60"
          name="artworkBidTime"
          @focus="onGetItem('5')"
          @click-right-icon="onGetItem('5')"
          :value="ruleForm.liveAuctionInfo.artworkBidTime"
          :rules="[{ required: isMore, message: '请输入时间' }]"
        /> -->
        <div class="leftText">
          <van-field
            :disabled="isEdit && ruleForm.roomStatus != 0"
            class="cellRow iconRight"
            v-show="isMore"
            v-model="ruleForm.liveAuctionInfo.artworkBidTime"
            required
            label="单件拍品的出价时间"
            maxlength="60"
            name="artworkBidTime"
            :rules="[{ required: isMore, message: '请输入时间' }]"
          />
          <p>分钟</p>
        </div>

        <div class="leftText" v-show="isMore">
          <van-field
            :disabled="isEdit && ruleForm.roomStatus != 0"
            required
            class="cellRow"
            label="买家佣金"
            v-model="commissionShow"
            name="commission"
            placeholder="请输入买家佣金"
            :rules="[{ required: isMore }]"
          />
          <p>%</p>
        </div>
        <van-field
          v-show="isMore"
          :disabled="isEdit && ruleForm.roomStatus != 0"
          required
          class="cellRow iconRight"
          v-model="ruleForm.showLotPicker"
          left-icon="info-o"
          @click-left-icon="
            portrait(
              '2位2/5/8的竞价阶梯，举例当前价为100元，则后几口价分别为120元、150元、180元、200元、220元，以此类推；固定金额的竞价阶梯，则需填写加价幅度，每次加价可加价固定金额的整数倍；自定义阶梯，需要到plat.zai-art.com后台中设置',
            )
          "
          label="竞价阶梯"
          readonly
          clickable
          name="resolutions"
          :value="ruleForm.resolutions"
          right-icon="arrow-down"
          @focus="onGetItem('6')"
          @click-right-icon="onGetItem('6')"
          :rules="[{ required: isMore, message: '请选择竞价阶梯' }]"
        />
        <div class="leftText" v-show="increaseShow && isMore">
          <van-field
            :disabled="isEdit && ruleForm.roomStatus != 0"
            required
            class="cellRow portrait"
            label="加价幅度"
            v-model="ruleForm.sellPrice"
            name="sellPrice"
            placeholder="请输入加价幅度"
            :rules="[{ required: increaseShow && isMore }]"
          />
          <p>元</p>
        </div>
        <!-- input -->
        <van-popup position="bottom" v-model="isPicker">
          <van-picker
            show-toolbar
            :columns="option1.columns"
            @confirm="onConfirmType"
            @cancel="isPicker = false"
            value-key="name"
            ref="isPicker"
            :default-index="0"
          />
        </van-popup>

        <van-field
          :disabled="isEdit"
          class="cellRow iconRight"
          v-show="isLot == 1"
          v-model="ruleForm.showGoodsPicker"
          label="关联类型"
          readonly
          clickable
          required
          name="goodsText"
          :value="ruleForm.goodsText"
          right-icon="arrow-down"
          @focus="onGetItem('3')"
          @click-right-icon="onGetItem('3')"
          :rules="[{ required: isLot == 1, message: '请选择关联类型' }]"
        />

        <van-field
          :disabled="isEdit && ruleForm.roomStatus != 0"
          v-show="isLot == 1 && ruleForm.showGoodsPicker == '商品'"
          class="cellRow portrait"
          right-icon="arrow"
          readonly
          label="直播商品"
          v-model="addMultipleSelectionLengthText"
          name="ruleFormGoods"
          placeholder="选择商品"
          @focus="relation('/rela/goodsList/')"
        />
        <van-field
          :disabled="isEdit && ruleForm.roomStatus != 0"
          v-show="isLot == 1 && ruleForm.showGoodsPicker == '作品'"
          class="cellRow portrait"
          right-icon="arrow"
          readonly
          label="直播作品"
          v-model="addMultipleSelectionLengthText"
          name="ruleFormArtwork"
          placeholder="选择作品"
          @focus="relation('/rela/artWork/')"
        />
        <van-field
          :disabled="isEdit"
          class="cellRow iconRight"
          v-show="isLot == 0"
          v-model="ruleForm.showAuctionPicker"
          label="关联类型"
          readonly
          clickable
          required
          name="auctionText"
          :value="ruleForm.auctionText"
          right-icon="arrow-down"
          @focus="onGetItem('2')"
          @click-right-icon="onGetItem('2')"
          :rules="[{ required: isLot == 0, message: '请选择关联类型' }]"
        />

        <van-field
          :disabled="isEdit && ruleForm.roomStatus != 0"
          right-icon="arrow"
          v-show="isLot == 0"
          label="选择拍品"
          readonly
          class="cellRow"
          v-model="addMultipleSelectionLengthText"
          name="ruleFormLot"
          placeholder="输入直播拍品"
          @focus="relation('/rela/aucArtwork/')"
        />
        <div class="grey"></div>

        <van-field
          class="cellRow"
          :disabled="disabled"
          v-model="ruleForm.liveDetail"
          type="textarea"
          name="liveDetail"
          label="直播说明"
          placeholder="请输入直播说明"
        />
        <div class="grey"></div>

        <van-field
          v-if="isStart == 2 || isStart == 3 || isEdit"
          class="cellRow"
          v-model="ruleForm.liveTime"
          name="liveTime"
          label="开播时间"
          readonly
          placeholder="开播时间"
          @click="onGetItem()"
          :rules="[{ required: isStart }]"
        />
        <van-popup v-model="showPickerDatetime" position="bottom">
          <van-datetime-picker
            label="开播时间"
            type="datetime"
            :value="currentDate"
            :min-date="minDate"
            @confirm="onInput"
            @cancel="showPickerDatetime = false"
          />
        </van-popup>

        <!-- select -->
        <van-field
          :disabled="isEdit && ruleForm.roomStatus != 0"
          class="cellRow iconRight"
          left-icon="info-o"
          @click-left-icon="
            portrait(
              '建议使用“高清540P”，网络状态很好时可选择“超清720P”， “蓝光1080P”对推流及观看端网络要求较高 谨慎选择',
            )
          "
          v-model="ruleForm.showPicker"
          label="清晰度"
          readonly
          clickable
          name="resolution"
          :value="ruleForm.resolution"
          right-icon="arrow-down"
          @focus="onGetItem('1')"
          @click-right-icon="onGetItem('1')"
          :rules="[{ required: true, message: '请选择清晰度' }]"
        />
        <van-cell center title="横屏直播" class="iconCell">
          <van-icon
            name="info-o"
            @click="
              portrait(
                '控制直播的横竖方向，连麦直播仅支持竖屏模式，需要到plat.zai-art.com后台中设置连麦直播',
              )
            "
          />
          <van-switch
            :disabled="isEdit && ruleForm.roomStatus != 0"
            v-model="ruleForm.screenOrientation"
            slot="right-icon"
            size="24"
            name="screenOrientation"
            :active-value="1"
            :inactive-value="0"
          />
        </van-cell>
        <van-field
          class="cellRow portrait iconLeft"
          right-icon="info-o"
          @click-right-icon="portrait('设置4位数字密码，将密码告诉观看人员，输入密码进入直播间')"
          label="直播间密码"
          v-model="ruleForm.liveRelaSecret.livePwd"
          name="usePwd"
          :maxlength="4"
          placeholder="直播间密码"
          type="number"
        />
        <van-cell center title="测试直播" class="iconCell">
          <van-icon
            name="info-o"
            @click="portrait('测试直播供测试使用，不会出现在“在艺直播”首页中')"
          />
          <van-switch
            v-model="ruleForm.isShow"
            slot="right-icon"
            size="24"
            :active-value="0"
            :inactive-value="1"
            :disabled="isShowDisabled"
          />
        </van-cell>
        <div class="submit">
          <van-button block type="info" native-type="submit">{{ createdText }}</van-button>
        </div>
      </van-form>
    </div>
    <van-popup v-model="isLoading" class="isLoading"> 加载中... </van-popup>
  </div>
</template>
<script>
import uploadImage from '../components/uploadImage';
import { liveCreate, liveView, liveUpdate, relateType, relateList, liveType } from '@/api/live';
import { formatDateTime, pullCustomPermission } from '@/utils/index';
import { Loading, Dialog, Toast } from 'vant';

export default {
  name: 'liveIndex',
  components: { uploadImage, Loading },
  data() {
    return {
      isLoading: false,
      uploadShow: true,
      showAuctionPicker: false,
      showGoodsPicker: false,
      isMore: false,
      isPicker: false,
      increaseShow: false,
      ruleForm: {
        specialMarginAmount: null,
        artWorkTime: '五分钟',
        liveAuctionInfo: {
          artworkBidTime: '5',
          marginPaymentType: 1,
          marginAmount: null,
          commission: null,
          biddingJson: null,
        },
        marginPaymentTypeText: '专场保证金',
        liveRelaSecret: {
          livePwd: null,
        },
        showGoodsPicker: '商品',
        showAuctionPicker: '限时拍',
        isClosed: false,
        usePwd: false,
        type: null,
        resolution: 0,
        resolutions: 0,
        title: null,
        liveTime: null, //开播时间
        imageUrl: null,
        liveDetail: null,
        ruleFormGoods: null,
        ruleFormLot: null,
        showTypePicker: null,
        showAuction: null,
        showPicker: '高清540P',
        showLotPicker: '2位2/5/8',
        screenOrientation: 0,
        auctionText: '限时拍',
        goodsText: 0,
        sellPrice: '',
        relaDataType: '31',
        // commissionShow: null,
        flagDelete: null,
        isShow: 1,
        saasDataType: '45',
        geo: {
          qLat: null,
          qLng: null,
        },
        isTiming: 0, // 是否定时，0 非定时，1定时
        timingReleaseDate: null, // 定时时间
      },
      option1: {
        columns: [],
      },
      showPicker: false,
      showTypePicker: false,
      resource: {},
      initData: [
        {
          type: '0',
          columns: [
            { code: 1, name: '普通导购直播', type: '0' },
            { code: 0, name: '拍品导购直播', type: '0' },
            { code: 3, name: '<span style="color:red">NEW </span>直播拍卖(边拍边播)', type: '0' },
          ],
        },
        {
          type: '1',
          columns: [
            { code: 0, name: '高清540P', type: '1' },
            { code: 1, name: '超清720P', type: '1' },
            { code: 2, name: '蓝光1080P', type: '1' },
          ],
        },
        {
          type: '2',
          columns: [
            { code: 0, name: '限时拍', type: '2' },
            { code: 1, name: '拍品上拍', type: '2' },
            { code: 2, name: '同步拍', type: '2' },
          ],
        },

        {
          type: '3',
          columns: [
            { code: 5, name: '商品', type: '3' },
            { code: 4, name: '作品', type: '3' },
          ],
        },
        {
          type: '4',
          columns: [
            { code: 1, name: '专场保证金', type: '4' },
            { code: 2, name: '拍品保证金', type: '4' },
          ],
        },
        {
          type: '5',
          columns: [
            { code: 5, name: '五分钟', type: '5' },
            { code: 10, name: '十分钟', type: '5' },
          ],
        },
        {
          type: '6',
          columns: [
            { code: 0, name: '2位2/5/8', type: '6' },
            { code: 1, name: '固定金额', type: '6' },
            { code: 2, name: '自定义阶梯', type: '6' },
          ],
        },
      ],
      minHour: 10,
      maxHour: 20,
      minDate: null,
      currentDate: new Date(),
      showPickerDatetime: false,
      isLot: null,
      multipleSelection: [],
      multipleSelectionLength: null,
      addMultipleSelectionLength: 0,
      addMultipleSelectionLengthText: null,
      isStart: null,
      imageUrl: [],
      createdText: '立即直播',
      isBack: true, // true  回退， false 不是回退
      isShowDisabled: false,
      commissionShow: 0,
    };
  },
  created() {
    this.minDate = new Date();

    // goodsList
  },
  watch: {
    commissionShow(value) {
      let tmp = value || value === 0 ? Number(value) / 100 : 0;
      if (tmp) tmp = tmp.toFixed(4);
      this.ruleForm.liveAuctionInfo.commission = tmp;
    },
    'ruleForm.liveAuctionInfo.artworkBidTime': value => {
      console.log(value);
      if (value > 60) {
        Toast('单件出价时间不可大于60分钟');
      }
    },
    // 'ruleForm.specialMarginAmount':(value)=>{
    //   console.log(value)
    //   if(value) this.ruleForm.liveAuctionInfo.marginAmount = value

    // }
  },
  activated() {
    this.getMaster();
    this.isBack = true;
    if (this.$route.params.id)
      this.pid = this.$route.params.id == 'all' ? '' : this.$route.params.id;
    // 是否是新建直播/创建预告
    if (this.$route.query.type) {
      this.isStart = this.$route.query.type;
      this.pid = null;
    }

    if (this.isStart == 1) {
      this.createdText = '立即直播';
    } else if (this.isStart == 2) {
      this.createdText = '创建预告';
    } else if (this.isStart == 3) {
      this.createdText = '创建直播';
      this.ruleForm.isShow = 0;
      this.isShowDisabled = true;
    } else {
      this.createdText = '保存直播';
    }
    this.isEdit = !!this.pid;
    if (this.$route.fullPath.indexOf('all') != -1) {
      this.isEdit = false;
    }
    const dataType = this.$route.query.dataType || null;
    this.multipleSelection = this.$store.state.app.multipleSelection;
    this.addMultipleSelectionLength = this.multipleSelection.length;
    //因页面缓存，初始化页面要清空数据
    if (this.pid && dataType == null) {
      if (!dataType) this.clearMultiple();
      this.init();
      // return;
    } else if (this.pid && dataType) {
      this.isLoading = false;
      // this.multipleSelectionLength +=this.addMultipleSelectionLength;
      this.addMultipleSelectionLengthText = `已选择${this.multipleSelectionLength +
        this.addMultipleSelectionLength}条数据`;
    } else {
      this.isLoading = false;
    }

    if (dataType == '46') {
      this.multipleSelection.map((item, index) => {
        this.multipleSelection[index] = {
          id: item.id,
          lot: item.lot || '',
        };
      });
    } else {
      let arr = [];
      this.multipleSelection.map((item, index) => {
        arr.push(item.id);
        this.multipleSelection.push(item.id);
      });
      this.multipleSelection = arr;
    }
    if (!this.isEdit) {
      this.multipleSelectionLength = this.addMultipleSelectionLength;
      this.addMultipleSelectionLengthText = `已选择${this.addMultipleSelectionLength}条数据`;
    }
  },
  methods: {
    formatDateTime,
    init() {
      this.isLoading = false;
      console.log(this.multipleSelection);
      if (this.isEdit) {
        this.editRender();
      }
    },
    getMaster() {
      // 检查是否有同步拍权限
      pullCustomPermission('pullCustomPermission', '同步拍').then(res => {
        if (!res.data.hasPermission) this.initData[2].columns.splice(2, 1);
      });
      // 检查是否有作品权限
      pullCustomPermission('pullCustomPermission', '/saas/cms/m/s/artwork/list').then(res => {
        if (!res.data.hasPermission) this.initData[3].columns.splice(1, 1);
      });
      liveType().then(res => {
        // res.data.list.find(i=>{
        this.initData[0].columns = [];
        res.data.list.map(v => {
          if (v.type == 3) {
            this.initData[0].columns.push({
              code: 3,
              name: '<span style="color:red">NEW </span>直播拍卖(边拍边播)',
              type: '0',
            });
          } else {
            this.initData[0].columns.push({ code: v.type, name: v.name, type: '0' });
          }
        });
        // })
        // this.initData[0].columns = Object
      });
    },
    // 获取编辑详情
    editRender() {
      liveView({ liveId: this.pid }).then(res => {
        Object.assign(this.ruleForm, res.data);
        const liveType = this.initData[0].columns;
        const typeArray = this.initData[1].columns;
        const artWorkType = this.initData[2].columns;
        const goodsType = this.initData[3].columns;
        //直播类型 //因产品要换位置，所以1=0  0=1 emmmmmmmmm
        if (res.data.type != 3) {
          this.ruleForm.showTypePicker = liveType[res.data.type == 0 ? 1 : 0].name;
          this.isLot = liveType[this.ruleForm.type == 0 ? 1 : 0].code;
        } else {
          this.commissionShow = res.data.liveAuctionInfo.commission
            ? res.data.liveAuctionInfo.commission * 100
            : 0;
          this.ruleForm.showTypePicker = '直播拍卖';
          this.isLot = 3;
        }
        this.multipleSelectionLength = this.ruleForm.dataCount;
        this.addMultipleSelectionLengthText = `已选择${this.ruleForm.dataCount +
          this.addMultipleSelectionLength}条数据`;
        this.ruleForm.showPicker = typeArray[res.data.resolution].name;

        this.ruleForm.liveTime = formatDateTime(res.data.liveTime);
        this.imageUrl = { keep: true, imageUrl: res.data.imageUrl };
        // this.ruleForm.showTypePicker = liveType[res.data.auctionType].name
        //判断直播类型  type: 5, name: '商品'，type: 4, name: '作品' , type: 0, name: '限时拍', type: 2, name: '同步拍', type: 1, name: '拍品上拍'
        if (res.data.relaDataType < 3) {
          this.ruleForm.showAuctionPicker = artWorkType[res.data.relaDataType].name;
          this.ruleForm.auctionText = artWorkType[res.data.relaDataType].code;
        } else if (res.data.relaDataType == 5) {
          this.ruleForm.showGoodsPicker = goodsType[0].name;
          this.ruleForm.goodsText = goodsType[0].code;
        } else {
          this.ruleForm.showGoodsPicker = goodsType[1].name;
          this.ruleForm.goodsText = goodsType[1].code;
        }
        //单件拍品出价时间
        // if (res.data.type == 3) {
        //   if (res.data.liveAuctionInfo.artworkBidTime == 5) {
        //     this.ruleForm.liveAuctionInfo.artworkBidTime = 5;
        //     this.ruleForm.artWorkTime = '五分钟';
        //   } else {
        //     this.ruleForm.liveAuctionInfo.artworkBidTime = 10;
        //     this.ruleForm.artWorkTime = '十分钟';
        //   }
        // }

        const date = new Date().getTime();
        if (date < res.data.liveTime) {
          this.isStart = 2;
        }
        // 获取竞价阶梯
        if (res.data.type == 3) {
          const biddingJson = JSON.parse(res.data.liveAuctionInfo.biddingJson).data || 2;
          console.log('biddingJson', biddingJson);
          if (biddingJson.length >= 1) {
            if (biddingJson[0].type == '2') {
              this.ruleForm.showLotPicker = '2位2/5/8';
              this.increaseShow = false;
            } else {
              this.ruleForm.showLotPicker = '固定金额';
              this.increaseShow = true;
              this.ruleForm.sellPrice = biddingJson[0].inputAmount;
            }
          } else {
            this.increaseShow = false;
            this.ruleForm.showLotPicker = '其他规格';
          }
        }
        if (this.ruleForm.liveAuctionInfo.marginPaymentType == 2) {
          this.ruleForm.marginPaymentTypeText = '拍品保证金';
          this.ruleForm.liveAuctionInfo.marginAmount = null;
        } else {
          this.ruleForm.marginPaymentTypeText = '专场保证金';
        }
      });
    },

    getOnruleFormSubmit(value) {
      console.log('value', value);
      const param = value;
      Object.assign(param, this.ruleForm, this.resource);
      if (!param.liveTime) {
        param.liveTime = new Date().getTime();
      } else if (param.liveRelaSecret.livePwd) {
        param.usePwd = true;
      }
      if (!param.imageUrl) {
        Toast('图片未上传成功，请稍后再试');
        return;
      }
      if (param.resolutions == 0) {
        param.liveAuctionInfo.biddingJson = {
          data: [{ min: '0', max: '∞', type: 2, amount: ['2位 2/5/8/0'], inputAmount: '0' }],
        };
      } else {
        param.liveAuctionInfo.biddingJson = {
          data: [
            {
              min: '0',
              max: '∞',
              type: 1,
              amount: [`${param.sellPrice}`],
              inputAmount: `${param.sellPrice}`,
            },
          ],
        };
      }
      if (param.type == 3 && param.liveAuctionInfo.artworkBidTime > 60) {
        Toast('单件出价时间不可大于60分钟');
        return;
      }
      param.liveAuctionInfo.liveId = this.pid || null;
      param.liveAuctionInfo.marginAmount = param.marginAmount || null;
      param.liveAuctionInfo.biddingJson = JSON.stringify(param.liveAuctionInfo.biddingJson);
      // 区分编辑/新增
      if (this.isEdit) {
        this.onEdit(param);
      } else {
        let liveTime = param.liveTime;
        if (typeof liveTime != Number) {
          liveTime = new Date(liveTime).getTime();
        }
        if ((this.isStart == 2 || this.isStart == 3) && liveTime < new Date().getTime()) {
          Toast('开播时间不能小于当前时间');
          return;
        }
        this.onAdd(param);
      }
    },
    // 新增直播
    onAdd(param) {
      this.isLoading = true;
      liveCreate(param)
        .then(res => {
          this.pid = res.data.id;
          if (!this.addMultipleSelectionLength <= 0) {
            this.relateAll();
          } else {
            this.jump();
          }
        })
        .catch(err => {
          this.clearData();
          this.isLoading = false;
        });
    },
    // 编辑直播
    onEdit(param) {
      this.isLoading = true;
      liveUpdate(param)
        .then(res => {
          if (!this.addMultipleSelectionLength <= 0) {
            this.relateAll();
          } else {
            this.isLoading = false;
            this.$router.replace('/live/list');
          }
        })
        .catch(err => {
          this.isLoading = false;
        });
    },
    // 关联
    relateAll() {
      const param = {
        id: this.pid || null,
        aucType: null,
      };
      // 1商品  0拍品
      if (this.isLot == 0) {
        param.auctionArtworkList = this.multipleSelection;
        param.dataType = 46;
      } else {
        param.dataIdList = this.multipleSelection;
        param.dataType = 31;
      }

      relateType(param)
        .then(res => {
          this.jump();
        })
        .catch(err => {
          this.isLoading = false;
          Toast('数据关联失败');
          this.jump();
        });
    },
    jump() {
      this.isLoading = false;
      this.clearData();
      console.log(this.isStart);
      if (this.isStart == 1) {
        let path = encodeURIComponent(
          `/pages/my/liverLiveList/index?phone=${this.$store.state.app.userPhone}&id=${this.pid}`,
        );
        let str = encodeURIComponent('点击进入“在艺直播”开播');
        wx.miniProgram.navigateTo({
          url: `/pages/openMini/index?path=${path}&appid=wx85f3340de9840fb8&title=${str}&id=${this.pid}`,
        });
        this.$router.replace('/live/list');
      } else {
        this.$store.state.app.multipleSelection = [];
        this.$router.replace('/live/list');
      }
    },
    uploadImageSuccess(imageResult) {
      Object.assign(this.resource, imageResult);
      // this.$emit('success', newResult);
    },
    deleteImage() {
      // this.$emit('delete', this.resource);
    },
    onConfirm(value, index) {
      this.multipleSelection = [];
      this.addMultipleSelectionLength = 0;
      this.addMultipleSelectionLengthText = `已选择${this.addMultipleSelectionLength}条数据`;
      this.$store.state.app.multipleSelection = [];
      // this.isLot == value.code;
      this.ruleForm.type = value.code;
      if (value.code == 3) {
        this.isMore = true;
        this.ruleForm.showTypePicker = '直播拍卖';
      } else {
        this.isMore = false;
        this.ruleForm.showTypePicker = value.name;
      }
      this.isLot = value.code;
      //relaDataType 0 默认限时拍  31商品  1边拍边播
      console.log(' value.code', value.code);
      if (value.code == 0) {
        this.ruleForm.relaDataType = 0;
      } else if (value.code == 1) {
        this.ruleForm.relaDataType = 31;
      } else {
        this.ruleForm.relaDataType = 1;
      }
    },
    onConfirms(value, index) {
      this.ruleForm.resolution = value.code;
      this.ruleForm.showPicker = value.name;
    },
    onConfirmrelaDataType(value) {
      console.log(value);
      console.log('this.isLot', this.isLot);
      this.ruleForm.relaDataType = value.code;
      this.ruleForm.showGoodsPicker = value.name;
      this.showGoodsPicker = false;
    },
    onConfirmType(value, index) {
      console.log('marginPaymentType', value);
      if (value.type == 0) {
        this.onConfirm(value, index);
      } else if (value.type == 1) {
        this.onConfirms(value, index);
      } else if (value.type == 2) {
        this.ruleForm.relaDataType = value.code;
        this.ruleForm.showAuctionPicker = value.name;
      } else if (value.type == 3) {
        this.onConfirmrelaDataType(value);
      } else if (value.type == 4) {
        this.ruleForm.marginPaymentTypeText = value.name;
        this.ruleForm.liveAuctionInfo.marginPaymentType = value.code;
      }
      // else if (value.type == 5) {
      //   this.ruleForm.liveAuctionInfo.artworkBidTime = value.code;
      //   this.ruleForm.artWorkTime = value.name;
      // }
      else if (value.type == 6) {
        if (value.code == 1) {
          this.increaseShow = true;
        } else if (value.code == 2) {
          Toast('自定义阶梯，请在电脑端进行处理');
          return;
        }
        this.ruleForm.resolutions = value.code;
        this.ruleForm.showLotPicker = value.name;
      }
      this.isPicker = false;
    },

    onGetItem(type) {
      let flage1 = this.isEdit && this.ruleForm.roomStatus != 0 && type == 0;
      let flage2 = this.isEdit && this.ruleForm.roomStatus != 0 && type == 1;
      if (flage1 || flage2) {
        return;
      }
      if (type) {
        this.option1.columns = this.initData[type].columns;
        this.isPicker = true;
        console.log(this.initData[type].columns);
      } else {
        this.showPickerDatetime = true;
      }
    },
    onInput(value) {
      let date = new Date(value);
      this.ruleForm.timingRelease = formatDateTime(date);
      this.ruleForm.liveTime = formatDateTime(date);
      this.ruleForm.isTiming = 1;
      this.showPickerDatetime = false;
    },
    // 关联跳转
    relation(url) {
      this.isBack = false;
      console.log(this.$store.state.app.multipleSelection);
      this.$store.state.app.multipleSelection = [];
      const id = this.pid || 'all';
      this.$router.push(url + id);
    },
    clearData() {
      console.log('clear');
      this.resource = {};
      this.commissionShow = 0;
      this.isStart = null;
      this.ruleForm = {
        liveRelaSecret: {
          livePwd: null,
        },
        isClosed: false,
        usePwd: false,
        type: null,
        resolution: 0,
        resolutions: 0,
        artWorkTime: '五分钟',
        liveAuctionInfo: {
          artworkBidTime: '5',
          marginPaymentType: 1,
          marginAmount: null,
          commission: null,
          biddingJson: null,
        },
        showAuction: null,
        showLotPicker: '2位2/5/8',
        auctionText: '限时拍',
        goodsText: 0,
        sellPrice: '',
        relaDataType: '31',
        commissionShow: null,
        marginPaymentTypeText: '专场保证金',
        title: null,
        liveTime: null, //开播时间
        imageUrl: null,
        liveDetail: null,
        ruleFormGoods: null,
        ruleFormLot: null,
        showTypePicker: null,
        showPicker: '高清540P',
        screenOrientation: 0,
        flagDelete: null,
        isShow: 1,
        saasDataType: '45',
        geo: {
          qLat: null,
          qLng: null,
        },
        isTiming: 0, // 是否定时，0 非定时，1定时
        timingReleaseDate: null, // 定时时间
      };
      this.uploadShow = false;
      this.imageUrl = null;
      this.multipleSelection = [];
      this.multipleSelectionLength = null;
      this.addMultipleSelectionLengthText = null;
      this.addMultipleSelectionLength = 0;
      this.isShowDisabled = false;
      this.isLoading = false;
      this.showAuctionPicker = false;
      this.showGoodsPicker = false;
      this.isMore = false;
      this.isPicker = false;
      this.increaseShow = false;
    },
    clearMultiple() {
      this.multipleSelection = [];
      this.multipleSelectionLength = null;
      this.addMultipleSelectionLengthText = null;
      this.addMultipleSelectionLength = 0;
    },
    portrait(message) {
      Dialog({ message });
    },
    isMoreShow(type) {
      this.isMore = !this.isMore;
    },
  },
  // 回退监听
  beforeRouteLeave(to, from, next) {
    if (this.isBack) {
      this.clearData();
    }
    next();
  },
};
</script>
<style lang="less" scoped>
.block {
  padding-bottom: 60px;
}
.grey {
  width: 100%;
  height: 10px;
  background: #f8f8f8;
}
.van-form .submit {
  position: fixed;
  width: 90%;
  left: 50%;
  bottom: 10px;
  border: none;
  max-width: 750px;
  transform: translateX(-50%);
  text-align: center;
}
.van-form .submit .van-button--info {
  background: #222;
  color: #fff;
  border: none;
}
.creatruleForm {
  padding-bottom: 80px;
}
.uploadImage .van-cell::after {
  border: none;
}
.van-form .proposalImage {
  background: #fff;
  font-size: 12px;
  color: #999;
  padding: 10px 16px;
}
/deep/ .isLoading {
  font-size: 14px;
  background: transparent;
  color: #fff;
}
/deep/ .iconLeft .van-field__body .van-field__right-icon {
  position: absolute;
  left: -2em;
}
/deep/ .iconRight .van-field__left-icon {
  position: absolute;
  left: 5.5em;
}
/deep/ .iconCell .van-cell__value {
  display: block;
  font-size: 16px;
  line-height: inherit;
  position: absolute;
  left: 5.5em;
}
/deep/ .van-form .van-cell,
/deep/ .van-form .van-cell .van-field__label,
/deep/ .iconCell .van-cell__value,
/deep/ .iconLeft .van-field__body .van-field__right-icon {
  color: #323233;
}
.van-form .leftText {
  position: relative;
}
.leftText p {
  position: absolute;
  right: 20px;
  top: 12px;
  color: #333;
  font-size: 14px;
}
</style>
